<!-- Button trigger modal -->
<template>
  <div>
    <div
      style="padding-right: 0 !important"
      class="modal fade"
      :class="[route === 'Sure' ? 'top-push' : '']"
      id="sub"
      tabindex="-1"
      role="dialog"
      aria-labelledby="sub"
      aria-hidden="true"
    >
      <div
        style="margin-bottom: 6rem;"
        class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable"
        role="document"
      >
        <div class="modal-content" style="margin-bottom: 30px">
          <div class="modal-header" style="border-bottom: 0.5px solid #e2e8f0">
            <!-- <h5 class="modal-title" id="sub">Modal title</h5> -->
            <button
              @click="selectedPlan = ''"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true" style="font-weight: normal">X</span>
            </button>
          </div>
          <div class="modal-body">
           <div class="d-none">
            <div>
              <img src="../assets/images/handshake-subscription.svg" alt="" />
            </div>
            <div class="top_header">
              <h4>Shelta Value Added Services</h4>
              <p>
                With Shelta, you don’t just pay rent — you pay for peace of mind, progress for your children, and a stronger future for your household.
                Subscribe today for ₦20,000/year.
              </p>
              <p>Shelta — Covering Africa, One Household at a Time</p>
            </div>
            <div>
              <p class="benefits-text">Benefits</p>
            </div>
            <div class="container">
              <div class="row">

                <div class="col-md-6 pl-0">
                  <div class="benefit-wraps">
                    <h6>
                      <span
                        ><img
                          src="../assets/images/check-circle-blue.svg"
                          alt=""/></span
                      >Flexible & Discounted Rent
                    </h6>
                    <p>
                      Pay monthly, quarterly, or biannually — and enjoy exclusive discounts on rents and other household essentials through Shelta.
                    </p>
                  </div>
                </div>
                <div class="col-md-6 pl-0">
                  <div class="benefit-wraps">
                    <h6>
                      <span
                        ><img
                          src="../assets/images/check-circle-blue.svg"
                          alt=""/></span
                      >Legal & Caretaker Support
                    </h6>
                    <p>
                      A personal caretaker to guide you on landlord-tenant issues and protect your household’s rights.
                    </p>
                  </div>
                </div>
                <div class="col-md-6 pl-0">
                  <div class="benefit-wraps">
                    <h6>
                      <span
                        ><img
                          src="../assets/images/check-circle-blue.svg"
                          alt=""/></span
                      >SuperKids, SuperTeens and SuperFam Enrollment
                    </h6>
                    <p>
                      Your children gain access to learning, fun and talent programs that help them shine.
                    </p>
                  </div>
                </div>
                <div class="col-md-6 pl-0">
                  <div class="benefit-wraps">
                    <h6>
                      <span
                        ><img
                          src="../assets/images/check-circle-blue.svg"
                          alt=""/></span
                      >Household Services
                    </h6>
                    <p>
                      From repairs (Fixr) to solar & energy (Watt), your home is always covered.
                    </p>
                  </div>
                </div>
                <div class="col-md-6 pl-0">
                  <div class="benefit-wraps">
                    <h6>
                      <span
                        ><img
                          src="../assets/images/check-circle-blue.svg"
                          alt=""/></span
                      >Homeownership Pathway
                    </h6>
                    <p>
                      Access mortgage facilitation & property financing to move closer to owning your dream home.
                    </p>
                  </div>
                </div>
                <div class="col-md-6 pl-0">
                  <div class="benefit-wraps">
                    <h6>
                      <span
                        ><img
                          src="../assets/images/check-circle-blue.svg"
                          alt=""/></span
                      >Shelta Rewards
                    </h6>
                    <p>
                      Earn CoverPoint & COVA points for essentials, bills, and emergencies.
                    </p>
                  </div>
                </div>
                <div class="col-md-6 pl-0">
                  <div class="benefit-wraps">
                    <h6>
                      <span
                        ><img
                          src="../assets/images/check-circle-blue.svg"
                          alt=""/></span
                      >Community Impact (SIP)
                    </h6>
                    <p>
                      Be part of projects like COVER — fixing leaking roofs, rehousing the vulnerable, and protecting families
                    </p>
                  </div>
                </div>
              </div>

              <div class="note">
                <h6>Note</h6>
                <ul>
                  <li>
                    This subscription is non-refundable.
                  </li>
                  <li>
                    Please note that subscription alone does not guarantee eligibility for Rent of Shelta property, Rent Financing or Gap Financing. T&C applies.
                  </li>
                </ul>
              </div>
            </div>
           </div>
           <!-- d-none -->
            <div class="top-header-sub ">
              <h3>One Subscription. One Household. Total Support.</h3>
              <p>Supporting your household across rent, maintenance, food, health, and family growth.</p>
            </div>
            <!-- d-none -->
            <div class="">
              <div v-if="loader || loader1">
                <PageLoader></PageLoader>
            </div>
              <div class="container">
                <div class="row">
                  <div class="col-md-6" v-for="(item, index) in paymentTypes" :key="index">
                    <div class="plans_wrap holder-price">
                      <div class="plans-holder" :class="[selectedPlan === index ? 'selectedPlan' : 'plans-holder']">
                        <div class="plan_price_holder">
                          <h3>{{item.name}}</h3>
                          <h4>Essential welfare tools and support for the everyday household.</h4>

                          <div>
                            <h2>₦{{Number(item.price).toLocaleString()}} <span>/ {{item.duration}}</span></h2>
                            <h6>₦00,000.00</h6>
                          </div>
                        </div>
                      </div>
                      <div class="plan_benefits" v-if="item.benefits.benefits">
                        <div class="d-flex align-items-baseline" v-for="(housing, index) in item.benefits.benefits.housing" :key="housing">
                          <span>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M11.334 2.22391C10.3534 1.65668 9.21492 1.33203 8.00065 1.33203C4.31875 1.33203 1.33398 4.3168 1.33398 7.9987C1.33398 11.6806 4.31875 14.6654 8.00065 14.6654C11.6825 14.6654 14.6673 11.6806 14.6673 7.9987C14.6673 7.5421 14.6214 7.09616 14.534 6.66536" stroke="#4688F4" stroke-width="1.5" stroke-linecap="round"/>
                              <path d="M5.33398 8.33203C5.33398 8.33203 6.33398 8.33203 7.66732 10.6654C7.66732 10.6654 11.3732 4.55425 14.6673 3.33203" stroke="#4688F4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </span>
                          <p>
                            {{housing}}
                          </p>
                        </div>
                        <div class="d-flex align-items-baseline" v-for="(lifestyle, index) in item.benefits.benefits.lifestyle" :key="lifestyle">
                          <span>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M11.334 2.22391C10.3534 1.65668 9.21492 1.33203 8.00065 1.33203C4.31875 1.33203 1.33398 4.3168 1.33398 7.9987C1.33398 11.6806 4.31875 14.6654 8.00065 14.6654C11.6825 14.6654 14.6673 11.6806 14.6673 7.9987C14.6673 7.5421 14.6214 7.09616 14.534 6.66536" stroke="#4688F4" stroke-width="1.5" stroke-linecap="round"/>
                              <path d="M5.33398 8.33203C5.33398 8.33203 6.33398 8.33203 7.66732 10.6654C7.66732 10.6654 11.3732 4.55425 14.6673 3.33203" stroke="#4688F4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </span>
                          <p>
                            {{lifestyle}}
                          </p>
                        </div>
                        <div class="d-flex align-items-baseline" v-for="(parenting, index) in item.benefits.benefits.parenting.tools" :key="parenting">
                          <span>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M11.334 2.22391C10.3534 1.65668 9.21492 1.33203 8.00065 1.33203C4.31875 1.33203 1.33398 4.3168 1.33398 7.9987C1.33398 11.6806 4.31875 14.6654 8.00065 14.6654C11.6825 14.6654 14.6673 11.6806 14.6673 7.9987C14.6673 7.5421 14.6214 7.09616 14.534 6.66536" stroke="#4688F4" stroke-width="1.5" stroke-linecap="round"/>
                              <path d="M5.33398 8.33203C5.33398 8.33203 6.33398 8.33203 7.66732 10.6654C7.66732 10.6654 11.3732 4.55425 14.6673 3.33203" stroke="#4688F4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </span>
                          <p>
                            {{parenting}}
                          </p>
                        </div>
                        <div class="d-flex align-items-baseline" v-for="(rewards, index) in item.benefits.benefits.rewards" :key="rewards">
                          <span>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M11.334 2.22391C10.3534 1.65668 9.21492 1.33203 8.00065 1.33203C4.31875 1.33203 1.33398 4.3168 1.33398 7.9987C1.33398 11.6806 4.31875 14.6654 8.00065 14.6654C11.6825 14.6654 14.6673 11.6806 14.6673 7.9987C14.6673 7.5421 14.6214 7.09616 14.534 6.66536" stroke="#4688F4" stroke-width="1.5" stroke-linecap="round"/>
                              <path d="M5.33398 8.33203C5.33398 8.33203 6.33398 8.33203 7.66732 10.6654C7.66732 10.6654 11.3732 4.55425 14.6673 3.33203" stroke="#4688F4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </span>
                          <p>
                            {{rewards}}
                          </p>
                        </div>
                        <div class="d-flex align-items-baseline" v-for="(support, index) in item.benefits.benefits.support" :key="support">
                          <span>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M11.334 2.22391C10.3534 1.65668 9.21492 1.33203 8.00065 1.33203C4.31875 1.33203 1.33398 4.3168 1.33398 7.9987C1.33398 11.6806 4.31875 14.6654 8.00065 14.6654C11.6825 14.6654 14.6673 11.6806 14.6673 7.9987C14.6673 7.5421 14.6214 7.09616 14.534 6.66536" stroke="#4688F4" stroke-width="1.5" stroke-linecap="round"/>
                              <path d="M5.33398 8.33203C5.33398 8.33203 6.33398 8.33203 7.66732 10.6654C7.66732 10.6654 11.3732 4.55425 14.6673 3.33203" stroke="#4688F4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </span>
                          <p>
                            {{support}}
                          </p>
                        </div>
                        
                      </div>

                      <!-- <div class="see_more">
                        <small>See more <span><i class="fa fa-chevron-down"></i></span></small>
                      </div> -->

                      <div class="plan_button">
                        <button class="btn" @click="openPaymentOption(item);" :disabled="user.house_hold_sub == (item.name).toLowerCase()">Choose Plan <span v-if="user.house_hold_sub == (item.name).toLowerCase()">(current)</span></button>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer modal-button main-footer-button d-none">
            <!-- <button type="button" class="btn cancel" data-dismiss="modal">
              Cancel
            </button> -->
            <!-- <button class="btn continue" data-toggle="modal"
              data-target="#paymentOption" @click="closeSubMOdal()">
              Become a Shelta User
            </button> -->
            <paystack
              type="button"
              class="btn continue"
              :disabled="subscribed === 'YES'"
              :amount="amount * 100"
              :email="email"
              :paystackkey="PUBLIC_KEY"
              :reference="reference"
              :callback="processPayment"
              :close="close"
              :channels="channels"
              @click="$refs.paystack.click()"
            >
              Continue as a SHELTA user
              <i class="fa fa-arrow-right"></i>
            </paystack>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal for benefits end -->

    <!-- Modal for amount confirmation begins -->
    <div
      tabindex="-1"
      class="modal fade"
      id="paymentConfirm"
      role="dialog"
      aria-labelledby="sub"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" style="margin-bottom: 30px; background: #F8F9FA;">
          <div class="modal-header">
            <div>
              <h5 class="modal-title confirmation-header text-left">
                Confirm payment
              </h5>
              <p class="confirmation-subheader">Please note that successful payent cannot be reversed.</p>
            </div>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true" style="font-weight: normal">X</span>
            </button>
          </div>
          <div class="modal-body body-confirmation">
            <h2 v-if="paymentType == 'paystack'">₦{{Number(paymentItem.final_paystack_amount - ( ( discount * 50 ) / 100 )).toLocaleString()}} </h2>
            <h2 v-if="paymentType == 'safe'">₦{{Number(paymentItem.final_safe_amount - discount).toLocaleString()}} </h2>
            <!-- <h2>₦20,000.00 </h2> -->
            <small v-if="applyDiscount && discount != '' && paymentType == 'paystack'">₦{{ Number(paymentItem.final_paystack_amount).toLocaleString() }}</small>
            <small v-if="applyDiscount && discount != '' && paymentType == 'safe'">₦{{ Number(paymentItem.final_safe_amount).toLocaleString() }}</small>

            <div>
              <div class="payment-con-item">
                <p>Available discount</p>
                <p>₦{{ Number(cova_balance_in_naira).toLocaleString() }} <span @click="applyDiscount = !applyDiscount; discount = ''">{{applyDiscount ? 'UNAPPLY' : 'APPLY'}}</span></p>
              </div>
              <div class="form-group" v-if="applyDiscount">
                <label for="discount" class="discount-label">Discount point:</label>
                <input v-if="paymentType == 'paystack'" @input="discount && (discount = Math.min(discount, Number(paymentItem.final_paystack_amount)))" v-model.number="discount" class="form-control" type="number" name="discount" id="discount" placeholder="Enter cover point"></input>
                <input v-if="paymentType == 'safe'" @input="discount && (discount = Math.min(discount, Number(paymentItem.final_safe_amount)))" v-model.number="discount" class="form-control" type="number" name="discount" id="discount" placeholder="Enter cover point"></input>
              </div>
              <div class="payment-con-item">
                <p>COVA</p>
                <p>{{ coverbalance - discount }} points</p>
              </div>
              <div class="payment-con-item">
                <p>Reward</p>
                <p>+{{ this.paymentItem.cova_reward }} points</p>
              </div>
              <hr>
              <div class="payment-con-item">
                <p>Payment type</p>
                <p>Subscription</p>
              </div>
              <div class="payment-con-item">
                <p>Payment method</p>
                <p style="text-transform:capitalize;">{{paymentType}}</p>
              </div>
             
            </div>
          </div>
          <div class="modal-footer modal-button">
            <button type="button" class="btn cancel" data-dismiss="modal" style="height: 40px;">
              Cancel
            </button>
            <button
              v-if="paymentItem && paymentType == 'safe'"
              type="button"
              class="btn continue"
              style="min-height: 40px;"
              @click="newHouseholdSubscription()"
            >
              Continue
              <i
              class="fa fa-spinner fa-spin  ml-3 f-12  btn-loader"
              v-if="loader1"
            ></i>
            </button>
            <paystack v-if="paymentItem && paymentType == 'paystack'"
                ref="paystack"
                :disabled="subscribed === 'YES'"
                :channels="channels"
                :amount="totalInKobo"
                :key="totalInKobo"
                :email="email"
                :paystackkey="PUBLIC_KEY"
                :reference="paymentItem.reference"
                :callback="newHouseholdSubscription"
                :close="close"
                class="btn continue d-flex justify-content-between"
                type="button"
                style="min-height: 40px !important;"
            >
             {{ loader1 ? 'Please wait' : ' Continue' }}
            <i
              class="fa fa-spinner fa-spin  ml-3 f-12  btn-loader"
              v-if="loader1"
            ></i>
            </paystack>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal for amount confirmation ends -->

    <!-- Modal for payment starts -->
    <div
      tabindex="-1"
      class="modal fade"
      id="paymentOption"
      role="dialog"
      aria-labelledby="sub"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content" style="margin-bottom: 30px">
          <div class="modal-header">
            <h5 class="modal-title confirmation-header">
              Payment Method
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span
                @click="paymentType = ''"
                aria-hidden="true"
                style="font-weight: normal"
                >X</span
              >
            </button>
          </div>
          <div class="modal-body">
            <div class="options">
              <button
                class="btn d-flex center justify-content-between"
                type="button"
                @click="
                  $refs.safe.click();
                  scrollView;
                "
              >
                
                <div class="d-flex align-items-center">
                  <img
                      style="width: 24px; margin-left: 10px;"
                      src="../assets/images/blue-safe.svg"
                      alt="safe"
                    />
                  <div>
                    <span class="pl-2">
                      SAFE
                    </span>
                    <h6>Available Safe Balance: <span>{{ Number(safebalance).toLocaleString() }}</span></h6>
                  </div>
                </div>

                <div>
                  <input
                  ref="safe"
                  v-model="paymentType"
                  value="safe"
                  style="width: 20px; height: 20px;"
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                />
                </div>
              </button>
              <button
                class="btn d-flex center justify-content-between"
                type="button"
                @click="
                  $refs.paystackicon.click();
                  scrollView;
                "
              >
                
                <div>
                  <img
                    style="width: 24px; margin-left: 10px;"
                    src="../assets/images/paystack-blue.svg"
                    alt="paystack"
                  />
                   <span class="pl-2">PAYSTACK</span>
                </div>

                <div>
                  <input
                  ref="paystackicon"
                  v-model="paymentType"
                  value="paystack"
                  style="width: 20px; height: 20px;"
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefault2"
                  id="flexRadioDefault1"
                />
                </div>
              </button>
              <button
                class="btn d-none center justify-content-between"
                type="button"
                @click="
                  $refs.voucher.click();
                  scrollView; openVouchModal();
                "
              >
                
                <div>
                  <img
                    style="width: 24px; margin-left: 10px;"
                    src="../assets/images/blue-safe.svg"
                    alt="safe"
                  />
                   <span class="pl-2">VOUCHER</span>
                </div>

                <div>
                  <input
                  ref="voucher"
                  v-model="paymentType"
                  value="voucher"
                  style="width: 20px; height: 20px;"
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                />
                </div>
              </button>
              <!-- <paystack v-if="paymentItem"
                ref="paystack"
                :disabled="subscribed === 'YES'"
                :channels="channels"
                :amount="paymentItem.final_paystack_amount * 100"
                :email="email"
                :paystackkey="PUBLIC_KEY"
                :reference="paymentItem.reference"
                :callback="newHouseholdSubscription"
                :close="close"
                class="btn d-flex justify-content-between"
                type="button"
                
              >
                
                <div>
                  <img
                    style="width: 24px; margin-left: 10px;"
                    src="../assets/images/paystack-blue.svg"
                    alt="paystack"/>
                    <span class="pl-2">Paystack</span>
                </div>

                <div>
                  <input
                    v-model="paymentType"
                    value="paystack"
                    ref="paystack"
                    style="width: 20px; height: 20px;"
                    class="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault1"
                  />
                </div>
              </paystack> -->
              <button
                class="btn d-none"
                type="button"
                @click="
                  $refs.bank.click();
                  payFromBank();
                "
              >
                <input
                  v-model="paymentType"
                  value="bank"
                  ref="bank"
                  style="width: 20px; height: 20px;"
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                /><img
                  style="margin-left: 10px;"
                  src="../assets/images/bank-transfer.svg"
                  alt="transfer"
                /><span class="pl-2">Bank Transfer</span>
              </button>
              <button
                class="btn d-none"
                type="button"
                @click="$refs.naira.click()"
              >
                <input
                  v-model="paymentType"
                  value="naira"
                  ref="naira"
                  style="width: 20px; height: 20px;"
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                /><img
                  style="width: 24px; margin-left: 10px;"
                  src="../assets/images/enaira-green.svg"
                  alt="enaira"
                /><span class="pl-2">E-Naira</span>
              </button>
            </div>
          </div>
          <div class="modal-footer modal-button">
            <button
              @click="paymentType = ''"
              type="button"
              class="btn cancel"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              :disabled="paymentType == ''"
              ref="continue"
              type="button"
              class="btn continue"
              @click="openConfirmationModal()"
            >
              Continue
              <i
                class="fa fa-spinner fa-spin ml-3 f-12 btn-loader"
                v-if="loader1"
              ></i>
            </button>
            <!-- <button
              ref="continue"
              v-if="paymentType === 'safe'"
              type="button"
              class="btn continue"
              @click="subscribeWithSafe"
            >
              Continue
              <i
                class="fa fa-spinner fa-spin ml-3 f-12 btn-loader"
                v-if="loader1"
              ></i>
            </button> -->
          </div>
        </div>
      </div>
    </div>
    <!-- Modal for payment ends -->

    <!-- Modal for bank statment upload begins -->
    <div
      class="modal fade"
      id="showpayment"
      tabindex="-1"
      role="dialog"
      aria-labelledby="showpayment"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header payment_header_holder">
            <img
              v-if="headerText2"
              @click="switchView(0)"
              class="back__arrow"
              src="../assets/images/arrow2-white.svg"
              alt=""
            />
            <img
              v-if="headerText3"
              @click="switchView(1)"
              class="back__arrow"
              src="../assets/images/arrow2-white.svg"
              alt=""
            />
            <h5
              v-if="headerText1"
              class="modal-title payment-header"
              id="exampleModalLongTitle"
            >
              Pay My Rent
            </h5>
            <h5
              v-if="headerText2"
              class="modal-title payment-header"
              id="exampleModalLongTitle"
            >
              Proof of payment upload.
            </h5>
            <h5
              v-if="headerText3"
              class="modal-title payment-header"
              id="exampleModalLongTitle"
            >
              Call Shelta.
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true" class="close_times">&times;</span>
            </button>
          </div>
          <div id="onee" class="modal-body">
            <div class="">
              <div class="dot-holder">
                <span class="step active"></span>
                <span class="step"></span>
                <span class="step"></span>
                <!-- <span class="step"></span> -->
              </div>
              <div class="double_arrow_holder">
                <img src="../assets/images/double-arrow-blue.svg" alt="back" />
                <p>Bank Transfer</p>
              </div>
              <div class="form-outter">
                <div class="first-step">
                  <div class="number__holder">
                    <p class="span-count">1</p>
                    <p>
                      Transfer the amount due to the acount number below
                    </p>
                  </div>

                  <div class="sheltaAccount__details">
                    <div>
                      <p>Amount:</p>
                      <p>
                        &#8358;10,000.
                      </p>
                    </div>
                    <div>
                      <p>Account Name:</p>
                      <p>Shelta Panacea Limited</p>
                    </div>
                    <div>
                      <p>Account Number :</p>
                      <p>0708490113</p>
                    </div>
                    <div>
                      <p>Bank :</p>
                      <p>Guarantee Trust Bank</p>
                    </div>
                  </div>
                  <div class="number__holder second__number">
                    <p class="span-count">2</p>
                    <p>
                      After the transfer is completed, please keep your payment
                      receipt by screenshot or photo and upload it in the next
                      step.
                    </p>
                  </div>

                  <div class="desclaimer__text">
                    <p>
                      Kindly note that your rent starts running 48 hours after
                      your payment is approved
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-foot">
              <button
                @click="switchView(1)"
                type="button"
                class="btn next-btn btn-block"
              >
                Next
              </button>
            </div>
          </div>

          <div id="twoo" class="modal-body">
            <div class="container-fluid">
              <div class="dot-holder">
                <span class="step"></span>
                <span class="step active"></span>
                <span class="step"></span>
              </div>
              <div class="form-outter">
                <div class="second-step">
                  <p class="info__text">
                    Please upload the payment receipt so that we can find your
                    payment.
                  </p>
                  <!-- <div class="dateOf__payment">
                    <label for="">Date of payment <span>*</span></label>
                    <input
                      class="form-control"
                      name="date"
                      type="date"
                      placeholder="Select date of payment"
                    />
                  </div> -->

                  <div class="upload__file">
                    <div class="dropzone">
                      <input
                        @change="selectFile"
                        class="input-file"
                        ref="file"
                        type="file"
                      />
                      <img src="../assets/images/file-upload.svg" alt="" />
                      <img
                        v-if="fileselected"
                        class="actual_image"
                        :src="filePath"
                        alt="reciept"
                      />
                      <p
                        v-if="!uploading && !fileselected"
                        class="call-to-action"
                      >
                        Drag and drop or
                        <span class="browse__span">browse</span> your files
                      </p>
                      <p
                        v-if="uploading"
                        class="call-to-action"
                        style="color: green;"
                      >
                        Uploding your reciept...
                      </p>
                      <!-- <p v-if="uploading" class="progress-bar">
                        <progress
                          class="progress is-primary"
                          :value="progress"
                          max="100"
                          >{{ progress }} %</progress
                        >
                      </p> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <p v-if="uploading" class="call-to-action" style="color: green;">
              Uploding your reciept...
            </p>
            <div class="modal-foot">
              <!-- switchView(2) -->
              <button
                @click="sendFile"
                type="button"
                class="btn next-btn btn-block"
              >
                SUBMIT
                <i
                  class="fa fa-spinner fa-spin  ml-3 f-12  btn-loader"
                  v-if="loading"
                ></i>
              </button>
            </div>
          </div>

          <div id="threee" class="modal-body">
            <div class="container-fluid">
              <div class="dot-holder">
                <span class="step"></span>
                <span class="step"></span>
                <span class="step active"></span>
              </div>
              <div class="form-outter">
                <div class="third-step">
                  <img src="../assets/images/rent-call.svg" alt="" />
                  <p>
                    Submited successfully ! We will confirm your payment and
                    update your status within 48 hours. For enquiries please
                    call our customer service agent on :
                  </p>
                </div>
              </div>
            </div>
            <div class="modal-foot">
              <button type="button" class="btn call-btn">
                <a href="tel:2348061796909">
                  <img src="../assets/images/phone-conect.svg" alt="" />
                  08061796909
                </a>
              </button>
            </div>
          </div>

          <!-- <div class="modal-footer modal-foot">
            
            <button type="button" class="btn next-btn btn-block">Next</button>
          </div> -->
        </div>
      </div>
    </div>

    <!-- Modal for bank statment upload ends -->

    <!-- Modal for voucher subscription starts -->
    <!-- Vertically centered modal -->
      


    <!-- Modal for voucher subscription ends -->
  </div>
</template>

<script>
import { Service } from "../store/service";
import paystack from "vue-paystack";
import PageLoader from "./PageLoader.vue";
import { staticdata } from "../../src/data";
const Api = new Service();
import $ from "jquery";
export default {
  name: "SubscriptionModal",
  components: {
    paystack,
    PageLoader
    // FooterMain,
  },
  data() {
    return {
      hideDiv: false,
      loading: false,
      loader: false,
      applyDiscount: false,
      amount: 0,
      selectedPlan: "",
      full_name: "",
      email: "",
      PUBLIC_KEY: staticdata.paystackkeylive,
      user: "",
      reference: "",
      subscribed: "",
      uploading: false,
      uploadFile: "",
      fileselected: false,
      filePath: "",
      progress: 0,
      file: "",
      headerText1: true,
      headerText2: false,
      headerText3: false,
      loader1: false,
      paymentType: "",
      channels: ["card", "bank", "ussd", "qr", "bank_transfer"],
      route: "",
      paymentTypes: [],
      paymentItem: '',
      amountToPay: "",
      discount: "",
      coverbalance: null,
      cova_balance_in_naira: null,
      safebalance: null
    };
  },

  computed: {
    totalInKobo() {
      // Perform calculation and ensure it is in Kobo (multiplied by 100)
      const baseAmount = Number(this.paymentItem.final_paystack_amount);
      const discountValue = (Number(this.discount) * 50) / 100;
      
      // Return final value in Kobo
      return (baseAmount - discountValue) * 100;
    }
    // amount() {
    //   // 1 point = 50 kobo = 0.5 Naira
    //   const discountInNaira = (Number(this.discount) * 50) / 100;
    //   const finalNaira = this.paymentItem.final_paystack_amount - discountInNaira;
      
    //   // Paystack requires amount in Kobo (Naira * 100)
    //   // Using Math.round to avoid floating point errors
    //   return Math.max(0, Math.round(finalNaira * 100));
    // },
  },
  // watch: {
  //   // The watcher name must match the data property name exactly
  //   discount(newValue) {
  //       if(newValue) {
  //         this.amount = (this.paymentItem.final_paystack_amount - ( Number(this.discount) * 50 ) / 100 ) * 100
  //       }
  //     // if (newValue > this.coverbalance) {
  //     //   alert("Warning: The entered amount exceeds the limit of " + this.coverbalance);
  //     // }
  //   }
  // },
  //   created() {
  //     this.$root.$refs.PropertyManagementAgreement = this === "Property Management Agreement";
  //   },
  created() {
    this.$root.$refs.D = this;
  },
  mounted() {
    this.getAllSubscriptionTypes();
    if (localStorage.getItem("shelta")) {
      this.getSubscription();
      this.user = JSON.parse(localStorage.getItem("shelta-user"));
      this.email = this.user.email;
      this.full_name = this.user.firstname + this.user.lastname;
    }
    this.route = this.$route.name;
  },
  methods: {
    openSubModal() {
      $("#sub")
        .addClass("fade")
        .modal("show");
    },
    closeConfirmation() {
      $("#paymentConfirm")
        .removeClass("fade")
        .modal("hide");
    },
    closeSubMOdal() {
      $("#sub")
        .removeClass("fade")
        .modal("hide");
    },

    openVouchModal() {
      $("#paymentOption")
        .removeClass("fade")
        .modal("hide");
    },
    openPaymentOption(item) {
      this.paymentItem = item;
      $("#paymentOption")
        .addClass("fade")
        .modal("show");
    },
    openConfirmationModal() {
      if(this.paymentType == 'safe' && this.safebalance < this.paymentItem.price) {
        return  this.$store.commit("setApiFailed", "Insufficient safe balance");
      }
      $("#paymentOption")
        .removeClass("fade")
        .modal("hide");
      $("#paymentConfirm")
        .addClass("fade")
        .modal("show");
    },
    newHouseholdSubscription() {
      this.loader1 = true;
      // this.amountToPay = null;
      if (this.paymentType === 'safe') {
        this.amountToPay = this.paymentItem.final_safe_amount;
      }
      if (this.paymentType === 'paystack') {
        this.amountToPay = this.paymentItem.final_paystack_amount;
      }


      // if (res.status === "success") {
        Api.postRequest(`pay-house-hold-subscription-robust`, {
          type: this.paymentItem.code,
          payment_method: this.paymentType,
          amount: Number(this.amountToPay),
          referencecode: this.paymentItem.reference,
          cova: this.discount
        })
          .then(res => {
            this.loader1 = false;
            // console.log("Subscription response", res);
            if (res.data.success === "success") {
              this.getSubscription();
              $("#sub")
                .removeClass("fade")
                .modal("hide");
                $("#paymentOption")
                .removeClass("fade")
                .modal("hide");
                $("#paymentConfirm")
                .removeClass("fade")
                .modal("hide");
                this.$store.commit(
                "setApiSuccess",
                "Subscription successful"
              );
              return window.location.reload();
            }
            if(res.data.error) {
              return this.$store.commit(
                "setApiFailed", res.data.error);
            }
          })
          .catch(err => {
            console.log("err", err);
            this.loader1 = false;
            // return this.$store.commit("setApiFailed", "Error occured");
          });
      // }
    },


    processPayment(res) {
      // console.log("clikedd", res);
      const ref = res.reference;
      if (res.status === "success") {
        Api.postRequest(`makesubscription`, {
          amount: 10000,
          referencecode: ref
        })
          .then(res => {
            // console.log("Subscription response", res);
            if (res.data.success === "success") {
              this.getSubscription();
              $("#sub")
                .removeClass("fade")
                .modal("hide");
              return this.$store.commit(
                "setApiSuccess",
                "Subscription successful"
              );
            }
          })
          .catch(err => {
            console.log("err", err);
            // return this.$store.commit("setApiFailed", "Error occured");
          });
      }
    },
    // Paystack close function or cancel payment
    close(){
      console.log("You closed checkout page");
      this.getPaystackRefKey()
      // $("#paymentConfirm")
      //   .removeClass("fade")
      //   .modal("hide");
      //   this.discount = '';
      //   this.paymentType = '';
      // this.closeConfirmation()
    },
    async getPaystackRefKey() {
      await Api.postRequest(`generate_paystack_reference`, {}).then(res => {
        this.paymentItem.reference = res.data.reference;
      }).catch(err => {
          console.log("err", err);
        });
    },
    async getAllSubscriptionTypes() {
      this.loader = true;
      try {
        await Api.getRequest(`get-new-household-subscription-details`)
          .then(res => {
            // console.log("Subscrion types", res);
            this.loader = false;
            if (res.data.success) {
              this.safebalance = res.data.safe_balance;
              this.coverbalance = res.data.cova_balance;
              this.cova_balance_in_naira = res.data.cova_balance_in_naira;
              this.paymentTypes = res.data.data;
            }
            // return this.$store.commit("setApiSuccess", "Sub success");
          })
          .catch(err => {
            console.log("err", err);
            this.loader = false;
            return this.$store.commit("setApiFailed", "Error occured");
          });
      } finally {
        // console.log("closed");
      }
    },
    async getSubscription() {
      this.hideDiv = true;
      try {
        await Api.getRequest(`checkifuserhassubscribed/${this.user.id}`)
          .then(res => {
            this.hideDiv = false;
            // console.log("Subscribed check", res);
            if (res.data.success === "success") {
              Api.userProfile();
              this.subscribed = res.data.paid;
            }
            // return this.$store.commit("setApiSuccess", "Sub success");
          })
          .catch(err => {
            console.log("err", err);
            this.hideDiv = false;
            return this.$store.commit("setApiFailed", "Error occured");
          });
      } finally {
        // console.log("closed");
      }
    },
    payFromSafe() {
      if (this.subscribed === "YES") {
        return this.$store.commit("setApiFailed", "You already scubscribed");
      } else {
        $("#paymentSafe")
          .addClass("fade")
          .modal("show");
      }
    },
    scrollView() {
      this.$refs.continue.scrollIntoView();
    },
    subscribeWithSafe() {
      this.loader1 = true;
      if (this.subscribed === "YES") {
        this.loader1 = false;
        return this.$store.commit("setApiFailed", "You already scubscribed");
      }
      Api.postRequest(`subscriptionwithsafe`, {})
        .then(res => {
          // console.log("res", res);
          this.loader1 = false;
          if (res.data.success) {
            $("#paymentOption")
              .removeClass("fade")
              .modal("hide");
            return this.$store.commit("setApiSuccess", "Success");
          }
          if (res.data.error) {
            return this.$store.commit("setApiFailed", res.data.error);
          }
        })
        .catch(err => {
          this.loader1 = false;
        });
    },
    makePayment() {
      // console.log("Payemt");
    },
    // Bank transfer starts
    payFromBank() {
      if (this.subscribed === "YES") {
        return this.$store.commit("setApiFailed", "You already subscribed");
      } else {
        $("#paymentOption")
          .removeClass("fade")
          .modal("hide");
        $("#showpayment")
          .addClass("fade")
          .modal("show");
      }
    },
    switchView(event) {
      if (event === 1) {
        document.getElementById("onee").style.display = "none";
        document.getElementById("twoo").style.display = "block";
        document.getElementById("threee").style.display = "none";
        this.headerText1 = false;
        this.headerText2 = true;
        this.headerText3 = false;
      } else if (event === 2) {
        document.getElementById("onee").style.display = "none";
        document.getElementById("twoo").style.display = "none";
        document.getElementById("threee").style.display = "block";
        this.headerText1 = false;
        this.headerText2 = false;
        this.headerText3 = true;
      } else if (event === 0) {
        document.getElementById("onee").style.display = "block";
        document.getElementById("twoo").style.display = "none";
        document.getElementById("threee").style.display = "none";
        // this.headerText2 = false;
      } else {
        document.getElementById("twoo").style.display = "none";
        document.getElementById("onee").style.display = "none";
        document.getElementById("threee").style.display = "block";
      }
    },

    selectFile() {
      const file = this.$refs.file.files[0];
      this.file = file;
      this.filePath = URL.createObjectURL(file);
      this.fileName = file.name;
      // console.log("fileeeeeeeeeeee", this.file);
      if (this.file) {
        this.fileselected = true;
      } else {
        this.fileselected = false;
      }
    },
    async sendFile() {
      // const file = this.$refs.file.files[0];
      // this.file = file;
      if (!this.file) {
        return this.$store.commit("setApiFailed", "No file was selected!");
      }
      const formData = new FormData();
      formData.append("file", this.file);
      try {
        this.uploading = true;
        this.loading = true;
        await Api.postRequest(`uploadsubscriptionpaymentslip`, formData, {
          onUploadProgress: e =>
            (this.progress = Math.round((e.loaded * 100) / e.total))
        })
          .then(res => {
            this.filenameRes = res.data.filename;
            this.uploading = true;
            this.uploadReceipt();
          })
          .catch(err => {
            this.loading = false;
            this.uploading = false;
          });
      } finally {
        // console.log("Closed connection");
      }
    },
    async uploadReceipt() {
      // this.loading = true;
      try {
        await Api.postRequest("makesubscriptionviatransfer", {
          amount: this.amount,
          filename: this.filenameRes
        })
          .then(res => {
            if (res.data.success) {
              this.switchView(2);
              this.uploading = false;
              this.loading = false;
              this.$store.commit("setApiSuccess", "Success");
            }
            if (res.data.error) {
              this.loading = false;
              this.uploading = false;
              this.$store.commit("setApiFailed", res.data.error);
            }
          })
          .catch(err => {
            this.uploading = false;
            this.loading = false;
          });
      } finally {
        // console.log("Closed connection");
      }
    }
  }
  // Bank transfer ends
};
</script>

<style lang="scss" scoped>
$primary: #0033ea;
$secondary: #ffffff;
$yellow: #ffb100;
$black: #000000;
$shelta-black: #000a2f;
$shelta-gray: #555c74;
$shelta-brown: #553b00;
$shelta-warning: #fff7e6;
$shelta-off-white: #f9fafb;
$shelta-grey-2: #57595a;
$dline: #dddddd;

@font-face {
  font-family: "Gotham-bold";
  src: local("Gotham-bold"),
    url("../assets/fonts/shelta_fonts/Gotham\ Bold.otf") format("truetype");
}

@font-face {
  font-family: "Gotham";
  src: local("Gotham"),
    url("../assets/fonts/shelta_fonts/Gotham\ Book.otf") format("truetype");
}

@font-face {
  font-family: "Gotham-medium";
  src: local("Gotham-medium"),
    url("../assets/fonts/shelta_fonts/Gotham\ Medium.otf") format("truetype");
}

// new payment subscription for household starts
.modal-content {
  background: #F8F9FA;
}
.holder-price {
  background: #ffffff;
  border-radius: 16px;
  padding: 24px 16px 32px 16px;

}
.top-header-sub {
  margin-top: 20px;
  h3 {
    font-family: Lato;
    font-weight: 700;
    font-size: 22px;
    line-height: 30px;
    color: #1A1A1A;
    text-align: center;
  }
  p {
    font-family: Lato;
    font-weight: 400;
    font-size: 16px;
    line-height: 25px;
    color: #555555;
    text-align: center;

  }
  
}
.plans-holder {
  margin-bottom: 15px;
  border: 1px solid #E6E9EC;
  background: #F8F9FA;
  padding: 12px 16px;
  border-radius: 12px;
}
.plan_price_holder {
  h3 {
    font-family: Lato;
    font-weight: 600;
    font-size: 22px;
    line-height: 30px;
    color: #1A1A1A;
    text-align: left;
    text-transform: uppercase;
  }
  h4 {
    font-family: Lato;
    font-weight: 400;
    font-size: 16px;
    line-height: 28px;
    color: #555555;
    text-align: left;

  }
  h2 {
    font-family: Lato;
    font-weight: 700;
    font-size: 22px;
    line-height: 28px;
    color: #2B3352;
    text-align: left;
    margin-bottom: 0;
    span {
      color: #9CA3AF;
      font-size: 14px;
    }
  }
  h6 {
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    line-height: 25px;
    text-decoration: line-through;
    text-align: left;
    color: #9CA3AF;
  }
}

.plan_benefits {
  margin-top: 20px;
  height: 136px;
  overflow-x: scroll;
  p {
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    line-height: 26px;
    color: #555555;
    text-align: left;
    padding-left: 5px;
  }
}

.plans_wrap {
  margin-bottom: 15px;
}
.see_more {
  text-align: left;
  margin-top: 10px;
  small {
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    line-height: 26px;
    color: #4688F4;
    text-align: left;
  }
}

.plan_button {
  margin-top: 30px;
  button {
    outline: 0;
    box-shadow: none;
    background: #0033EA;
    color: #ffffff;
    font-family: Lato;
    font-size: 16px;
    width: 100%;
    span {
      font-size: 12px;
    }
  }
}
// new payment subscription for household ends


.top-push {
  margin-top: 7rem;
  // margin-bottom: 5rem;
}
// Pleas to comment out start

.top_header {
  padding: 24px 0px 16px;

  h4 {
    font-family: Gotham;
    color: $shelta-black;
    font-weight: 500;
    font-style: normal;
    font-size: 20px;
    line-height: 25px;
  }

  p {
    font-family: Gotham;
    color: $shelta-gray;
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
    line-height: 21px;
  }
}

.benefits-text {
  text-align: left;
  color: $shelta-black;
  font-family: Gotham-medium;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.2px;
}

.benefit-wraps {
  text-align: left;

  h6 {
    color: $shelta-black;
    text-align: left;
    font-family: Gotham-medium;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 19px;
    display: flex;

    span {
      padding-right: 10px;
    }
  }

  p {
    padding-left: 30px;
    color: $shelta-gray;
    font-family: Gotham;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }
}

.note {
  text-align: left;
  margin-top: 20px;
  padding: 24px 16px;
  background: $shelta-warning;

  h6 {
    color: $shelta-brown;
    font-family: Gotham-bold;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
  }

  ul {
    padding-left: inherit;
  }

  li {
    color: $shelta-brown;
    font-family: Gotham;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    padding-bottom: 16px;
  }

  li:last-child {
    padding-bottom: 0;
  }
}

.main-footer-button {
  justify-content: space-around !important;
}

// Pleas to comment out ends
.modal-button {
  padding-top: 24px;
  padding-bottom: 24px;
  display: flex;
  justify-content: space-between;
  border-top: none !important;

  .cancel {
    border-radius: 6px;
    border: 1px solid $dline;
    color: $shelta-black;
    width: 178px;
    height: 48px;
    text-align: center;
    font-family: Gotham;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    outline: 0;
    box-shadow: none;
  }

  .continue {
    border-radius: 6px;
    background: $primary;
    color: $secondary;
    // width: 178px;
    min-height: 48px;
    text-align: center;
    font-family: Gotham;
    font-size: 16px;
    font-style: normal;
    outline: 0;
    box-shadow: none;
  }
}

.confirmation-header {
  color: $shelta-black;
  text-align: center;
  font-family: Gotham;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 125%;
}
.confirmation-subheader {
  font-family: Lato;
  font-weight: 400;
  font-size: 15px;
  line-height: 28px;
  text-align: left;
  color: #555555;
  margin-bottom: 0;
}

.body-confirmation {
  h2 {
    font-family: Lato;
    font-weight: 700;
    font-size: 26px;
    line-height: 28px;
    text-align: center;
    color: #1A1A1A
  }
  small {
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    line-height: 28px;
    text-align: center;
    color: #555555;
    text-decoration: line-through;
  }
  div {
    background: #F8F9FA;
    border-radius: 8px;
    padding: 2px 15px;
    
  }
  input {
    border: 1px solid #BDBDBD;
    outline: 0;
    box-shadow: none;
  }
}
.payment-con-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  p {
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #555555;
    span {
      background: #FFB100;
      color: #ffffff;
      font-size: 12px;
      border-radius: 50px;
      padding: 5px 14px;
      cursor: pointer;
      margin-left: 7px;
    }
  }
  p:first-child {
    text-align: left;
  }
  p:last-child {
    text-align: right;
  }
}
.discount-label {
  text-align: left;
  font-family: Lato;
  font-size: 14px;
  display: flex;
}

.confirmation-body {
  p {
    text-align: left;
    color: $shelta-black;
    font-family: Gotham;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin-bottom: 10px;
  }

  span {
    font-weight: bold;
  }
}

// New payment design start
.options {
  button {
    display: block;
    width: 100%;
    text-align: left;
    border-radius: 5px;
    background: $shelta-off-white;
    color: $shelta-grey-2;
    font-family: Gotham;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    margin-bottom: 16px;
    outline: 0;
    box-shadow: none;
    border: 1px solid #E6E9EC;
    padding: 16px;
    // padding-left: 35px;
    padding-left: 5px;
  }
  h6 {
    font-family: Lato;
    font-weight: 400;
    font-size: 12px;
    // line-height: 26px;
    margin-left: 0.5rem;
    margin-bottom: 0;
    span {
      color: #0033ea;
    }
  }
}
.selectedPlan {
  border: 1px solid #0033EA;
}

// New payment design ends

// Bank transfer upload modal
.payment_header_holder {
  background: $primary;
}

.payment-header {
  font-family: Gotham;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  display: flex;
  align-items: flex-end;
  color: $secondary;
}

.close_times {
  color: #ea0000;
  background: $secondary;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  padding: 0px 6px;
}

.dot-holder {
  text-align: left;
  margin-top: -10px;
  margin-bottom: 10px;
}

.double_arrow_holder {
  p {
    margin-top: 5px;
    color: $primary;
    font-family: Gotham;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 30px;
  }
}

.step {
  height: 15px;
  width: 15px;
  margin: 0 2px;
  background-color: #bbbbbb;
  border: none;
  border-radius: 50%;
  display: inline-block;
  opacity: 0.5;
}

.step.active {
  // opacity: 1;
  background-color: $primary;
}
.step.finish {
  background-color: #04aa6d;
}

#twoo {
  display: none;
}
#threee {
  display: none;
}

//  First step starts here
.number__holder {
  text-align: left;
  display: flex;
  p:first-child {
    background: $primary;
    // padding: 0.3rem 0.69rem;
    border-radius: 50px;
    color: $secondary;
    text-align: center;
    align-items: baseline;
    margin-right: 16px;
    font-family: Gotham;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    width: 1.5rem;
    height: 1.5rem;
    padding: 0.5rem;
    line-height: 11px;
    // width: 2rem;
    // height: 1.5rem;
  }
  p:nth-child(2) {
    font-family: Gotham;
    font-style: normal;
    font-weight: bold;
    font-size: 13px;
    line-height: 22px;
    color: $black;
    margin-right: 1rem;
  }
}

.sheltaAccount__details {
  background: rgba(64, 123, 255, 0.46);
  margin: 0 -16px 15px -16px;
  // margin-bottom: 15px;
  div {
    display: flex;
    justify-content: space-between;
    margin: 0 3.5rem;
    padding-top: 10px;
    p:first-child {
      font-family: Gotham;
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      line-height: 30px;
      color: $black;
      text-align: left;
      margin-bottom: 0;
    }

    p:nth-child(2) {
      font-family: Gotham;
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      line-height: 22px;
      color: $black;
      text-align: right;
      margin-bottom: 0;
    }
  }
}

.next-btn {
  background: $primary;
  border-radius: 5px;
  font-family: Gotham;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 30px;
  color: $secondary;
  margin-bottom: 1rem;
  margin-top: 2rem;
  box-shadow: none;
}

.desclaimer__text {
  // padding-top: 4rem;
  p {
    font-family: Gotham;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 30px;
    color: $primary;
    text-align: left;
    margin-left: 2.5rem;
  }
}

.modal-foot {
  border-top: none;
}
// Firts modal steps ends

// Secosn modal steo start
.info__text {
  font-family: Gotham;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 30px;
  color: $black;
  text-align: left;
}

.dateOf__payment {
  label {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 30px;
    display: flex;
    color: $black;
  }
  input {
    width: 100%;
    border-bottom: 0.5px solid #6c6c6c !important;
    border: none;
    border-radius: 0;
    box-shadow: none;
  }
}

.upload__file {
  .dropzone {
    border: 0.5px solid #c4c4c4;
    box-sizing: border-box;
    border-radius: 10px;
    margin: 20px 0;
    padding: 50px 5px;
    min-height: 200px;
    cursor: pointer;
    position: relative;
    p {
      margin-bottom: 0;
      padding-top: 10px;
      font-family: Gotham;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 30px;
      color: $black;
    }
    .browse__span {
      color: $primary;
    }
  }
}
.dropzone:hover {
  background-color: lightgrey;
}

// .input-file {
//   opacity: 0;
//   width: 100%;
//   left: 0%;
//   height: 200px;
//   position: absolute;
//   cursor: pointer;
// }
.input-file {
  opacity: 0;
  width: 100%;
  top: 0;
  left: 0%;
  // height: 200px;
  position: absolute;
  height: 100%;
  object-fit: contain;
  z-index: 10;
  cursor: pointer;
}

.actual_image {
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  z-index: 0;
  position: absolute;
  left: 0%;
  cursor: pointer;
}

.third-step {
  p {
    font-family: Gotham;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 30px;
    // display: flex;
    // align-items: flex-end;
    text-align: center;
    color: $black;
    padding-top: 3rem;
    padding-bottom: 1rem;
  }
}

.call-btn {
  background: #f2f5fe;
  border: 0.5px solid #6c6c6c;
  box-sizing: border-box;
  border-radius: 10px;

  // width: 154px;
  font-family: Gotham;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  box-shadow: none;
  // display: flex;
  // align-items: flex-end;
  text-align: center;
  color: $black;
  padding: 6px 26px;
  a {
    img {
      width: 27.01px;
      margin-right: 1rem;
    }
  }
}

.back__arrow {
  padding-top: 0.7rem;
  cursor: pointer;
  margin-right: 10px;
}

// Second modal step ends

// Bank transfer modal upload ends

@media only screen and (max-width: 599px) {
  .modal-button {
    display: flex;
    width: auto;
    flex-wrap: nowrap;

    button {
      width: fit-content;
    }
  }

  .top_header {
    h4 {
      font-size: 19px;
    }
  }

  // Bank transfer
  .info__text {
    text-align: justify;
  }
  .number__holder {
    p:nth-child(2) {
      line-height: 23px;
      text-align: left;
      font-size: 13px;
    }
  }
  .sheltaAccount__details {
    div {
      margin: 5px 15px;
      p:first-child {
        font-size: 13px;
      }
      p:nth-child(2) {
        font-size: 13px;
      }
    }
  }
  .body-confirmation {
   div {
    padding: 0 15px;
   } 
  }
  .second__number {
    padding-top: 2rem;
  }
  .desclaimer__text {
    // padding-top: 1rem;
    p {
      font-size: 13px;
      line-height: 25px;
      text-align: left;
    }
  }
  .payment-header {
    font-size: 15px;
  }
  .third-step {
    p {
      font-size: 13px;
      line-height: 24px;
      text-align: left;
      padding-top: 2rem;
    }
  }
  .call-btn {
    font-size: 13px;
    padding: 6px 34px;
    a {
      img {
        margin-right: 2rem;
        width: 20.01px;
      }
    }
  }
  .third-step {
    img {
      width: 7rem;
    }
  }
  // Bank transfer
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>
